<template>
  <TableDataTable
    ref="tableDataTableRef"
    :isTableLoading="isTableLoading"
    :imageManagementData="imageManagementData"
    :selectedSectionState="selectedSectionState"
    :selectedFieldState="selectedFieldState"
    :sectionsDataByDocId="sectionsDataByDocId"
    :customizedVersionSelectedDocId="selectedSectionState.docId"
    :docsDataByDocId="docsDataByDocId"
    newRowPosition="start"
    v-bind="tableProps"
  />
</template>

<script>
import {
  ref,
  watch,
  reactive,
  computed,
  nextTick,
} from 'vue'

import { cloneDeep } from 'lodash'
import { emptyObject } from '@/utils'

import TableDataTable from '@/components/ApiDoc/editor/TableDataTable.vue'

export default {
  name: 'ReleaseVerSection',
  components: {
    TableDataTable,
  },
  props: {
    imageManagementData: Array,
    selectedSectionState: Object,
    selectedFieldState: Object,
    releaseVerFieldsByDocId: Object,
    sectionsDataByDocId: Object,
    docsDataByDocId: Object,
  },
  setup(props, { expose }) {
    const isTableLoading = ref(false)
    const tableDataTableRef = ref(null)

    const selectedFieldState = reactive(props.selectedFieldState)

    watch(
      [
        () => props.selectedSectionState.docId,
        () => props.selectedSectionState.sectionId,
      ],
      async ([newDocId, newSectionId], [oldDocId, oldSectionId]) => {
        if (newSectionId !== 'ReleaseVer') return

        console.log('[ReleaseVerSection] watch selectedSectionState.docId & selectedSectionState.sectionId', {
          newDocId, oldDocId, newSectionId, oldSectionId,
        })

        emptyObject(selectedFieldState)
        Object.assign(selectedFieldState, cloneDeep(props.releaseVerFieldsByDocId[newDocId]))
        console.log('[ReleaseVerSection] selectedFieldState', selectedFieldState)
      },
      { immediate: true },
    )

    const tableProps = computed(() => {
      if (!props.selectedSectionState?.tableColumns) return {}

      const { tableColumns } = props.selectedSectionState
      const sortedColumns = Object.keys(tableColumns).sort((a, b) => tableColumns[a].sortOrder - tableColumns[b].sortOrder).map(col => tableColumns[col])

      return {
        columns: sortedColumns.map(({
          columnId, columnTitle, sortOrder, ...column
        }) => ({
          title: columnTitle,
          dataIndex: columnId,
          key: columnId,
          ...(sortOrder === 0 && { fixed: 'left' }),
          ...column,
          ...(columnId === 'version' && {
            width: '100px',
            required: true,
            pattern: /^\d{1,2}\.\d{1,2}\.\d{1,2}$/,
            errorMessage: 'Please enter the correct format (x.x.xx), such as: 1.0.05',
          }),
          ...(columnId === 'content' && {
            width: '400px',
          }),
          ...(columnId === 'updateDate' && {
            width: '100px',
            pattern: /^\d{4}\/\d{2}\/\d{2}$/,
            errorMessage: 'Please enter the correct format (YYYY/MM/DD), such as: 2026/01/05',
          }),
        })),
      }
    })

    const waitForTableRef = async (maxMs = 3000) => {
      const deadline = Date.now() + maxMs
      while (Date.now() < deadline) {
        if (tableDataTableRef.value?.focusTableCellValidationErrorInput) return tableDataTableRef.value
        await nextTick()
        await new Promise(resolve => requestAnimationFrame(resolve))
      }
      return tableDataTableRef.value
    }

    const focusTableValidationErrorIfNeeded = async () => {
      const tableRef = await waitForTableRef()
      if (!tableRef?.checkTableCellValidationError?.()) return false
      if (tableRef.focusTableCellValidationErrorInput) {
        await tableRef.focusTableCellValidationErrorInput()
      }
      return true
    }

    const refocusTableValidationErrorIfNeeded = async () => {
      const tableRef = await waitForTableRef()
      if (tableRef?.refocusTableCellValidationErrorInput) {
        return tableRef.refocusTableCellValidationErrorInput()
      }
      return false
    }

    expose({
      focusTableValidationErrorIfNeeded,
      refocusTableValidationErrorIfNeeded,
    })

    return {
      isTableLoading,
      tableDataTableRef,
      selectedFieldState, // eslint-disable-line vue/no-dupe-keys
      tableProps,
    }
  },
}
</script>
